export default __webpack_public_path__ + "static/media/080_finish_soso.hevc.73d9fd33.mp4";